import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { useState } from 'react';
import { z } from 'zod';

// Import existing types to use in function signatures
import { Employee } from '../../models/Employee';
import { UserSchema } from '../schemas/userSchemas';

/**
 * Hook for getting current user with built-in state management
 * Includes Zod validation for type safety
 */
export const useGetUser = () => {
  const { callAPI } = useAPI(); // GET

  const [data, setData] = useState<Employee | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  /**
   * Get current user
   * @returns Promise with boolean indicating success
   */
  const action = async (): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await callAPI(buildApiUrl('user'));

      // Validate the response data
      const validatedData = /* UserSchema.parse( */ response /* ) */ as Employee;

      setData(validatedData);
      return true;
    } catch (error) {
      console.error('Error in useGetUser:', error);
      setError(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isLoading,
    error,
    action,
  };
};
